import defaultPerfil from "../../assets/defaultUserImage.png";
import React, {  useEffect, useState } from "react";
import LogoEmpresa from "../../assets/IsoLogo.png";
import "./HeaderbarHome.css";
import HeaderTimer from "../HeaderTimer/HeaderTimer";
import camelize from "global/utils/camelize";
import { getStrDate } from "global/utils/diasData";

const HeaderbarHome = ({ onShowBurguerHandle }) => {

  const [showDropPerfil, setShowDropPerfil] = useState(false);
  const imgAvatar = "";

  const onHandleClickAvatar = () => {
    if (!showDropPerfil) {
      setShowDropPerfil(true);
    } else {
      setShowDropPerfil(false);
    }
  };


  const [nombreUsuario, setNombreUsuario] = useState("");
  const obtenerTokenStorage = async () => {
    const itemStorage = localStorage.getItem("dtoSegundoFactor");
    const itemToken = JSON.parse(itemStorage);
    if (itemToken) {
      setNombreUsuario(itemToken.nombre);
    }
  };

  const nameCamelized = () => {
    let name = nombreUsuario;
    return camelize(name);
  };

  useEffect(() => {
    obtenerTokenStorage();
  }, []);

  return (
    <React.Fragment>
      <div
        className={`ptur-HeaderbarDiv-background ${
          !showDropPerfil ? "disable" : ""
        }`}
        onClick={onHandleClickAvatar}
      ></div>
      <div className="ptur-HeaderbarDiv c-white">
        <div className="logoHeader">
          <img className="ptur-logoHeader" src={LogoEmpresa} alt="logo"></img>
        </div>
        <div className="ptur-RightMenu">
          <div className="ptur-headerBarHome-txtDiaHora">
            <p id="ptur-DiaResponsive" className="rb18m">
              {getStrDate(new Date())}
              <span className="ptur-timer">
                <HeaderTimer />
              </span>
            </p>
          </div>
          <div className="ptur-perfilMenu">
            <p className="rb18b">{nameCamelized()}</p>
            <div
              onClick={onHandleClickAvatar}
              className="ptur-flechaAvatar-box"
            >
              <div className="ptur-perfilMenu-perfilImg-box">
                <img
                  className={
                    showDropPerfil
                      ? `ptur-perfilMenu-perfilImg-img clickedAvatar`
                      : `ptur-perfilMenu-perfilImg-img`
                  }
                  src={
                    imgAvatar
                      ? `data:image/jpeg;base64,${imgAvatar}`
                      : defaultPerfil
                  }
                  alt="Perfil"
                />
              </div>
              {/* {showDropPerfil ? (
                <div style={{ position: "relative" }}>
                  <div className="ptur-flechaAvatar img-rotatedX180">
                    <FlechaDropdown color={"var(--color-primary)"} />
                  </div>
                  <div className="ptur-dropDownAvatar2-box dropdownSidebar">
                    <div className="ptur-dropDownAvatar2">
                      <ul className="ptur-dropDownAvatar2-list pointer rb18m">
                        <li
                          onClick={onHandleVerPerfil}
                          className="ptur-dropDownAvatar2-listItem"
                        >
                          <MiniAvatar className={"ptur-dropDownAvatar2-icons"} />
                          <span>Ver mi perfil</span>
                        </li>
                        <li
                          onClick={onHandleSalir}
                          className="ptur-dropDownAvatar2-listItem"
                        >
                          <SalirIconDrop
                            className={"ptur-dropDownAvatar2-icons"}
                          ></SalirIconDrop>
                          <span>Salir</span>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              ) : (
                <div className="ptur-flechaAvatar pointer">
                  <FlechaDropdown color={"var(--color-white)"} />
                </div>
              )} */}
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default HeaderbarHome;
